import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Table, Container, Modal } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import api from '../../api/apiweb-factura.js';
import Rut from "rutjs";
import TIPOS_DOCUMENTO_REFERENCIA from '../../constants/tiposReferencia';
import { v4 as uuidv4 } from 'uuid';



function FacturaFormulario(props) {
  const initialState = {
    emisor: {
      rut: "",
      razonSocial: "",
      direccion: "",
      comuna: "",
      ciudad: "",
      tipoVenta: "Del Giro",
      acteco: "",
      email: "",
      telefono: "",
      giro: "",
    },
    receptor: {
      rut: "",
      razonSocial: "",
      tipoCompra: "Del Giro",
      direccion: "",
      comuna: "",
      ciudad: "",
      giro: "",
      contacto: "",
      rutSolicita: "",
    },
    productos: [],
    formaPago: "1",
    referencias: [],
    mostrarReferencias: false,
  };

  const [formData, setFormData] = useState(initialState);
  // const [emailError, setEmailError] = useState("");
  // const [telefonoError, setTelefonoError] = useState("");
  const [rutReceptorError, setRutReceptorError] = useState("");
  const [rutSolicitaError, setRutSolicitaError] = useState("");
  const [erroresReceptor, setErroresReceptor] = useState([]);
  const [mostrarModalErrores, setMostrarModalErrores] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorApi, setErrorApi] = useState(null);
  const [mostrarModalErrorApi, setMostrarModalErrorApi] = useState(false);
  const [erroresProducto, setErroresProducto] = useState([]);
  const [mostrarModalErroresProducto, setMostrarModalErroresProducto] = useState(false);
  const [mostrarModalReferenciaInvalida, setMostrarModalReferenciaInvalida] = useState(false);
  const [erroresReferencia, setErroresReferencia] = useState([]);
  const [mostrarModalPdf, setMostrarModalPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [jsonPendienteEnvio, setJsonPendienteEnvio] = useState(null);
  const [inputsTemporales, setInputsTemporales] = useState({});
  const [actecoOpciones, setActecoOpciones] = useState([]);
  const [fechaEmision, setFechaEmision] = useState("");
  const [urlLogo, setUrlLogo] = useState("");



  // 1. Subtotal por ítem con su descuento (entero redondeado por ítem)
  const subtotal = Math.round(formData.productos.reduce((acc, producto) => {
    const cantidad = parseFloat(producto.cantidad || 0);
    const precio = parseFloat(producto.precio || 0);
    const descuento = parseFloat(producto.descuento || 0);

    const bruto = cantidad * precio;
    const descuentoItem = bruto * (descuento / 100);
    const netoItem = bruto - descuentoItem;

    return acc + netoItem;
  }, 0));


  // 2. Neto + IVA + Total (todo redondeado)
  const montoNeto = subtotal;
  const tasaIVA = 19;
  const montoIVA = Math.round(montoNeto * (tasaIVA / 100));
  const total = Math.round(montoNeto + montoIVA);


  const [visibleSections, setVisibleSections] = useState({
    emisor: true,
    receptor: true,
    transporte: true,
  });

  // Eliminar una referencia
  const eliminarReferencia = (index) => {
    const nuevasReferencias = [...formData.referencias];
    nuevasReferencias.splice(index, 1);
    setFormData((prev) => ({ ...prev, referencias: nuevasReferencias }));
  };

  const toggleSection = (section) => {
    setVisibleSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleInputChange = (e, section, field) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };


  const actualizarProducto = (index, campo, valor) => {
    setFormData((prev) => {
      const nuevosProductos = [...prev.productos];
      nuevosProductos[index] = {
        ...nuevosProductos[index],
        [campo]: valor,
      };
      return { ...prev, productos: nuevosProductos };
    });
  };


  const handleFormaPagoChange = (e) => {

    console.log("forma de pago:", e.target.value);
    setFormData((prev) => ({
      ...prev,
      formaPago: e.target.value,
    }));
  };

  const handleLimpiarFormulario = () => {
    setFormData((prev) => ({
      ...initialState,
      emisor: { ...prev.emisor },
    }));


    setRutReceptorError("");
    setRutSolicitaError("");
    // setTelefonoError("");
    // setEmailError?.("");


    setErroresReceptor([]);
    setMostrarModalErrores(false);
  };

  const eliminarProducto = (index) => {
    const nuevosProductos = [...formData.productos];
    nuevosProductos.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      productos: nuevosProductos,
    }));
  };

  // Agrega una nueva fila vacía a la tabla de referencias
  const agregarReferencia = () => {
    setFormData((prev) => ({
      ...prev,
      referencias: [
        ...prev.referencias,
        {
          tipoDoc: "",
          folio: "",
          fecha: "",
          razon: "",
        },
      ],
    }));
  };

  // Actualiza un campo de una referencia específica
  const actualizarReferencia = (index, campo, valor) => {
    const nuevasReferencias = [...formData.referencias];
    nuevasReferencias[index][campo] = valor;
    setFormData((prev) => ({
      ...prev,
      referencias: nuevasReferencias,
    }));
  };


  const generarJsonFactura = () => {

    const subtotal = formData.productos.reduce((acc, producto) => {
      const cantidad = parseFloat(producto.cantidad || 0);
      const precio = parseFloat(producto.precio || 0);
      const descuento = parseFloat(producto.descuento || 0); // % de descuento

      const totalSinDescuento = cantidad * precio;
      const montoDescontado = totalSinDescuento * (descuento / 100);
      const totalConDescuento = totalSinDescuento - montoDescontado;

      return acc + totalConDescuento;
    }, 0);

  
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0); 
    const fechaemisionDate = new Date(fechaEmision);
    const errores = [];
    // console.log("fechaemision", fechaEmision);
    // console.log("hoy", hoy);
    if ( fechaemisionDate > hoy) {
      errores.push("La fecha de emisión no puede ser mayor al día actual.");
      setMostrarModalErrores(true);
      setErroresReceptor(errores);
      return false;
    }
    if ( fechaEmision === "") {
      errores.push("La fecha de emisión no puede ser nula.");
      setMostrarModalErrores(true);
      setErroresReceptor(errores);
      return false;
    }

    if (!validarReceptor()) {

      return false;
    }
    if (!validarProductos()) {

      return false;
    }

    if (!validarReferencias()) {

      return false;
    }

    // Calcular IVA y total
    const tasaIVA = 19; // 19% de IVA
    const iva = Math.round((subtotal * tasaIVA) / 100);
    const total = Math.round(subtotal + iva);

    // Generar el JSON

    // console.log(formData);
 
    const jsonGenerado = {
      ID: uuidv4(),
      Encabezado: {
        IdDoc: {
          TipoDTE: "33",
          FchEmis: fechaEmision,
          TpoTranCompra: "1",
          TpoTranVenta: "1",
          FmaPago: formData.formaPago,
        },
        Emisor: {
          RUTEmisor: new Rut(formData.emisor.rut).rut,
          RznSoc: formData.emisor.razonSocial,
          GiroEmis: formData.emisor.giro,
          CorreoEmisor: formData.emisor.email,
          Acteco: formData.emisor.acteco,
          CdgSIISucur: "12345678", //TODO: Revisar
          DirOrigen: formData.emisor.direccion,
          CmnaOrigen: formData.emisor.comuna,
          CiudadOrigen: formData.emisor.ciudad,
          TipoVenta: formData.emisor.tipoVenta,
          Telefono: formData.emisor.telefono,
        },
        Receptor: {
          RUTRecep: new Rut(formData.receptor.rut).rut,
          RznSocRecep: formData.receptor.razonSocial,
          GiroRecep: formData.receptor.giro,
          DirRecep: formData.receptor.direccion,
          CmnaRecep: formData.receptor.comuna,
          CiudadRecep: formData.receptor.ciudad,
          Contacto: formData.receptor.contacto,
          RutSolicita: formData.receptor.rutSolicita,
          TipoCompra: formData.receptor.tipoCompra,

        },
        Totales: {
          MntNeto: montoNeto,
          TasaIVA: tasaIVA,
          IVA: iva,
          MntTotal: total,
        },
      },
      Detalle: formData.productos.map((producto, index) => {
        const cantidad = parseInt(producto.cantidad || 0);
        const precio = parseFloat(producto.precio || 0);
        const descuento = parseFloat(producto.descuento || 0);

        const montoSinDescuento = cantidad * precio;
        const montoDescuento = Math.round(montoSinDescuento * (descuento / 100));
        const montoFinal = montoSinDescuento - montoDescuento;

        const detalleItem = {
          NroLinDet: index + 1,
          NmbItem: producto.nombre,
          DscItem: producto.descripcion,
          QtyItem: cantidad,
          PrcItem: precio,
          UnmdItem: producto.unidad,
          MontoItem: montoFinal,
        };

        if (descuento > 0) {
          detalleItem.DescuentoPct = +descuento.toFixed(2);
          detalleItem.DescuentoMonto = montoDescuento;
        }

        return detalleItem;
      }),
      ...(formData.mostrarReferencias && formData.referencias.length > 0 && {
        Referencia: formData.referencias.map((referencia, index) => ({
          NroLinRef: index + 1,
          TpoDocRef: referencia.tipoDoc,
          FolioRef: referencia.folio,
          FchRef: referencia.fecha,
          RazonRef: referencia.razon,
        })),
      })
    };
    // console.log("jsonGenerado", JSON.stringify(jsonGenerado));

    return jsonGenerado;



  }

  const handleVisuavilizar = async () => {
    setLoading(true);

    try {
      const dte = generarJsonFactura();
      // console.log("dte", dte);
      // return
      if (!dte) return;

      const json = {
        dte,
        preview: true
      };
      console.log("json", JSON.stringify(json));

      const response = await api.previewFactura(json);

      // Convertir base64 a blob
      const byteCharacters = atob(response.data); // Base64 to binary
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      setPdfUrl(url);
      setJsonPendienteEnvio(json.dte);
      setMostrarModalPdf(true);

    } catch (error) {
      console.error("Error al previsualizar factura:", error.message);
      setErrorApi("Ocurrió un error al generar el PDF.");
      setMostrarModalErrorApi(true);
    } finally {
      setLoading(false);
    }
  };

  const validarReceptor = () => {
    const receptor = formData.receptor;
    const errores = [];

    const rutValido = new Rut(receptor.rut).validate();
    
    if (!rutValido) {
      errores.push("El RUT del receptor es inválido.");
      setRutReceptorError("RUT inválido");
    } else {
      setRutReceptorError("");
    }



    const camposObligatorios = [
      { campo: "razonSocial", etiqueta: "Razón Social" },
      { campo: "tipoCompra", etiqueta: "Tipo de Compra" },
      { campo: "direccion", etiqueta: "Dirección" },
      { campo: "comuna", etiqueta: "Comuna" },
      { campo: "ciudad", etiqueta: "Ciudad" },
      { campo: "giro", etiqueta: "Giro" },
    ];

    if (receptor.razonSocial.length > 100) errores.push("Razón Social no puede superar los 100 caracteres.");
    if (receptor.giro.length > 80) errores.push("Giro no puede superar los 80 caracteres.");
    if (receptor.contacto.length > 80) errores.push("Contacto no puede superar los 80 caracteres.");
    if (receptor.direccion.length > 70) errores.push("Dirección no puede superar los 70 caracteres.");
    if (receptor.comuna.length > 20) errores.push("Comuna no puede superar los 20 caracteres.");
    if (receptor.ciudad.length > 20) errores.push("Ciudad no puede superar los 20 caracteres.");

    camposObligatorios.forEach(({ campo, etiqueta }) => {
      if (!receptor[campo] || receptor[campo].trim() === "") {
        errores.push(`El campo "${etiqueta}" es obligatorio.`);
      }
    });

    if (receptor.rutSolicita && receptor.rutSolicita.trim() !== "") {
      const rutSolicitaValido = new Rut(receptor.rutSolicita).validate();
      if (!rutSolicitaValido) {
        errores.push("El RUT de quien solicita es inválido.");
        setRutSolicitaError("RUT inválido");
      } else {
        setRutSolicitaError("");
      }
    }

    if (errores.length > 0) {
      setErroresReceptor(errores);
      setMostrarModalErrores(true);
      return false;
    }
    else {
      return true;
    }


  };

  const validarProductos = () => {
    const errores = [];

    formData.productos.forEach((producto, index) => {
      const numeroFila = index + 1;

      if (!producto.nombre || producto.nombre.trim() === "") {
        errores.push(`Fila ${numeroFila}: El nombre del producto es obligatorio.`);
      }

      if (producto.cantidad === undefined || isNaN(producto.cantidad) || parseFloat(producto.cantidad) <= 0) {
        errores.push(`Fila ${numeroFila}: La cantidad debe ser un número mayor a 0.`);
      }

      if (producto.precio === undefined || isNaN(producto.precio) || parseFloat(producto.precio) <= 0) {
        errores.push(`Fila ${numeroFila}: El precio debe ser un número mayor a 0`);
      }

      if (producto.descuento !== undefined && (!/^\d{0,3}(\.\d{1,2})?$/.test(producto.descuento) || parseFloat(producto.descuento) > 100)) {
        errores.push(`Fila ${numeroFila}: El descuento debe ser un número entre 0 y 100 con hasta 2 decimales.`);
      }
    });

    if (errores.length > 0) {
      setErroresProducto(errores);
      setMostrarModalErroresProducto(true);
      return false;
    }

    return true;
  };

  const validarReferencias = () => {
    const errores = [];

    if (formData.mostrarReferencias === false) return true; // Si no se muestran referencias, no validamos

    formData.referencias.forEach((ref, index) => {
      const fila = index + 1;

      // Tipo de documento (obligatorio)
      if (!ref.tipoDoc || ref.tipoDoc.trim() === "") {
        errores.push(`Referencia ${fila}: El tipo de documento es obligatorio.`);
      }

      // Folio (obligatorio)
      if (!ref.folio || ref.folio.trim() === "") {
        errores.push(`Referencia ${fila}: El folio es obligatorio.`);
      }

      // Fecha (obligatoria y no mayor al día actual)
      if (!ref.fecha || ref.fecha.trim() === "") {
        errores.push(`Referencia ${fila}: La fecha es obligatoria.`);
      } else {
        const fechaReferencia = new Date(ref.fecha);
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // quitar hora para comparar solo fecha

        if (fechaReferencia > hoy) {
          errores.push(`Referencia ${fila}: La fecha no puede ser mayor al día actual.`);
        }
      }

      // Razon (opcional, pero validar largo si lo incluye)
      if (ref.razon && ref.razon.length > 90) {
        errores.push(`Referencia ${fila}: La razón no puede exceder los 90 caracteres.`);
      }
    });

    if (errores.length > 0) {
      setErroresReferencia(errores);
      setMostrarModalReferenciaInvalida(true);
      return false;
    }

    return true;
  };

  const formatearMiles = (valor) => {
    if (typeof valor !== "number" || isNaN(valor)) return "";

    const [enteros, decimales] = valor
      .toFixed(2)
      .split('.');

    // Agrega puntos a los miles
    const miles = enteros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Si hay decimales distintos de 00, los mostramos con coma
    return decimales !== "00" ? `${miles},${decimales}` : miles;
  };




  const handleRutReceptorChange = (e) => {
    const input = e.target.value;

    // Limpiar caracteres no válidos (solo dígitos y k/K)
    const limpio = input.replace(/[^0-9kK]/g, '');

    // ⚠️ Si el valor está vacío, solo lo actualizamos sin validar
    if (limpio === "") {
      setFormData((prev) => ({
        ...prev,
        receptor: {
          ...prev.receptor,
          rut: "",
        },
      }));
      setRutReceptorError("");
      return;
    }

    try {
      const rutObj = new Rut(limpio);
      const rutFormateado = rutObj.getNiceRut(); // formateado con puntos y guion
      const esValido = rutObj.validate();

      setFormData((prev) => ({
        ...prev,
        receptor: {
          ...prev.receptor,
          rut: rutFormateado,
        },
      }));

      setRutReceptorError(esValido ? "" : "RUT inválido");
    } catch (err) {
      // console.error("Error al formatear el RUT:", err);

      // fallback: mostrar el valor como estaba ingresado
      setFormData((prev) => ({
        ...prev,
        receptor: {
          ...prev.receptor,
          rut: input,
        },
      }));
      setRutReceptorError("RUT inválido");
    }
  };

  const handleRutSolicitaChange = (e) => {
    const input = e.target.value;
    const limpio = input.replace(/[^0-9kK]/g, '');

    if (limpio === "") {
      setFormData((prev) => ({
        ...prev,
        receptor: {
          ...prev.receptor,
          rutSolicita: "",
        },
      }));
      setRutSolicitaError("");
      return;
    }

    try {
      const rutObj = new Rut(limpio);
      const rutFormateado = rutObj.getNiceRut();
      const esValido = rutObj.validate();

      setFormData((prev) => ({
        ...prev,
        receptor: {
          ...prev.receptor,
          rutSolicita: rutFormateado,
        },
      }));

      setRutSolicitaError(esValido ? "" : "RUT inválido");
    } catch (err) {
      // console.error("Error al formatear el RUT Solicita:", err);
      setFormData((prev) => ({
        ...prev,
        receptor: {
          ...prev.receptor,
          rutSolicita: input,
        },
      }));
      setRutSolicitaError("RUT inválido");
    }
  };



  // const handleEmailChange = (e) => {
  //   const email = e.target.value;

  //   // Guardar siempre el valor que escribe el usuario
  //   setFormData((prev) => ({
  //     ...prev,
  //     emisor: {
  //       ...prev.emisor,
  //       email,
  //     },
  //   }));

  //   // Validar formato
  //   if (!validarEmail(email)) {
  //     setEmailError("Formato de correo inválido");
  //   } else {
  //     setEmailError(""); // limpio el error si es válido
  //   }
  // };

  // const validarEmail = (email) => {
  //   const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   return regex.test(email);
  // };

  // const handleTelefonoChange = (e) => {
  //   const input = e.target.value;
  //   const telefonoFormateado = formatearTelefonoChileno(input);

  //   let soloNumeros = telefonoFormateado.replace(/\D/g, '');

  //   // Permitir vacío sin marcar error
  //   if (soloNumeros === "") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       emisor: {
  //         ...prev.emisor,
  //         telefono: "",
  //       },
  //     }));
  //     setTelefonoError("");
  //     return;
  //   }

  //   // Eliminar 56 si está
  //   if (soloNumeros.startsWith("56")) {
  //     soloNumeros = soloNumeros.slice(2);
  //   }

  //   const valido = soloNumeros.length === 9 && /^[2-9]\d{8}$/.test(soloNumeros);

  //   setFormData((prev) => ({
  //     ...prev,
  //     emisor: {
  //       ...prev.emisor,
  //       telefono: telefonoFormateado,
  //     },
  //   }));

  //   setTelefonoError(valido ? "" : "Número inválido. Ej: +56 9 1234 5678 o +56 71 2983656");
  // };





  // const formatearTelefonoChileno = (input) => {
  //   let numeros = input.replace(/\D/g, '');

  //   // Si no hay nada, no formateamos
  //   if (numeros === "") return "";

  //   // Quitar el 56 si viene
  //   if (numeros.startsWith("56")) {
  //     numeros = numeros.slice(2);
  //   }

  //   numeros = numeros.slice(0, 9);

  //   // Si ya está vacío después de quitar 56, no formateamos
  //   if (numeros === "") return "";

  //   if (numeros.startsWith("9")) {
  //     return `+56 9 ${numeros.slice(1, 5)} ${numeros.slice(5, 9)}`.trim();
  //   } else {
  //     return `+56 ${numeros.slice(0, 2)} ${numeros.slice(2, 9)}`.trim();
  //   }
  // };


  useEffect(() => {
    const cargarDatosEmpresa = async () => {
      if (props.empresas && props.empresas.length > 0) {
        const empresa = props.empresas[0];
        const nicerut = new Rut("" + empresa.rut, true).getNiceRut();
        if(empresa.logo!=null){
          setUrlLogo(empresa.logo);
        }

        // Obtener acteco
        try {
          const actecoData = (await api.getActeco()).data.records;
          const artecoOpc = actecoData.map((item) => ({
            value: item.codigo,
            label: `${item.nombre}`
          }
          ));
          // console.log(actecoData[0].codigo);

          setActecoOpciones(artecoOpc);
          // console.log(artecoOpc);

          setFormData((prev) => ({
            ...prev,
            emisor: {
              rut: nicerut || "",
              razonSocial: empresa.name || "",
              direccion: empresa.direccion || "",
              comuna: empresa.comuna || "",
              ciudad: empresa.ciudad || "",
              email: empresa.email || "",
              telefono: empresa.telefono || "",
              giro: empresa.giro || "",
              tipoVenta: empresa.tipoVenta || "Del Giro",
              acteco: actecoData.length > 0 ? actecoData[0].codigo : "",
            },
          }));
          // console.log(formData)
        } catch (error) {
          console.error("Error al obtener Acteco:", error);
        }
      }
    };

    cargarDatosEmpresa();
  }, [props.empresas]);

  // useEffect(() => {
  //   setPrecioInput(formatearMiles(nuevoProducto.precio));
  // }, [nuevoProducto.precio]);

  // useEffect(() => {
  //   setCantidadInput(formatearMiles(nuevoProducto.cantidad));
  // }, [nuevoProducto.cantidad]);



  const handleEnviarFactura = async (e) => {
    console.log("crear factura", e);
    console.log("jsonPendienteEnvio", jsonPendienteEnvio);

    const resp = await api.createFactura(jsonPendienteEnvio);
    console.log("respuesta", resp);
  }


  return (
    <Container>
      <h2 className="text-center my-4">Factura Electrónica</h2>

      {/* Encabezado con logo + info empresa */}
      <div className="d-flex justify-content-between align-items-start mb-3">
        {/* Logo a la izquierda */}
        <div>
          <img src={urlLogo} alt="" style={{ maxHeight: "150px" }} />
        </div>

        {/* Info superior derecha en recuadro */}
        <div className="border rounded p-3" style={{ minWidth: "400px" }}>
          <div className="text-end">
            <div><strong>Rut {formData.emisor.rut}</strong></div>
            <div>FACTURA ELECTRÓNICA</div>
            <div className="text-muted">N° folio no asignado</div>
          </div>


          <Form.Group className="mt-4">
            <Form.Label className="mb-0"><strong>Fecha Emisión</strong></Form.Label>
            <Form.Control
              type="date"
              value={fechaEmision}
              onChange={(e) => setFechaEmision(e.target.value)}
            />
          </Form.Group>
        </div>
      </div>

      {/* Datos del Emisor */}
      <div className="border p-3 mb-5">
        <h5
          onClick={() => toggleSection("emisor")}
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          Datos Emisor
          {visibleSections.emisor ? <FaChevronUp /> : <FaChevronDown />}
        </h5>

        {visibleSections.emisor && (
          <Row>
            {/* Campos existentes */}
            <Col md={8} className="mb-3">
              <Form.Group>
                <Form.Label>Razón Social</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.emisor.razonSocial}
                  readOnly
                />
              </Form.Group>
            </Col>


            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.emisor.direccion}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.emisor.comuna}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.emisor.ciudad}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Teléfono</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.emisor.telefono}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={formData.emisor.email}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={8} className="mb-3">
              <Form.Group>
                <Form.Label>Giro</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.emisor.giro}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Tipo de Venta</Form.Label>
                <Form.Select
                  value={formData.emisor.tipoVenta}
                  onChange={(e) => handleInputChange(e, "emisor", "tipoVenta")}
                >
                  <option value="Del Giro">Del Giro</option>
                  <option value="Ventas que no son del Giro">Ventas que no son del giro</option>
                  <option value="Ventas de bienes inmuebles">Ventas de bienes inmuebles</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={8} className="mb-3">
              <Form.Group>
                <Form.Label>Act. Econo.</Form.Label>
                <Form.Select
                  value={formData.emisor.acteco || ""}
                  onChange={(e) =>
                    handleInputChange(e, "emisor", "acteco")
                  }
                >
                  {actecoOpciones.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        )}
      </div>

      {/* Datos Receptor */}
      <div className="border p-3 mb-4">
        <h5
          onClick={() => toggleSection("receptor")}
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          Datos Receptor
          {visibleSections.receptor ? <FaChevronUp /> : <FaChevronDown />}
        </h5>

        {visibleSections.receptor && (
          <Row>
            {/* RUT */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>RUT</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="RUT"
                  value={formData.receptor.rut}
                  onChange={handleRutReceptorChange}
                  isInvalid={!!rutReceptorError}
                />
                <Form.Control.Feedback type="invalid">
                  {rutReceptorError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Razón Social */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Razón Social</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Razón Social"
                  value={formData.receptor.razonSocial}
                  onChange={(e) => handleInputChange(e, "receptor", "razonSocial")}
                  maxLength={100}
                />
              </Form.Group>
            </Col>

            {/* Tipo de Compra */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Tipo de Compra</Form.Label>
                <Form.Select
                  value={formData.receptor.tipoCompra}
                  onChange={(e) => handleInputChange(e, "receptor", "tipoCompra")}
                >
                  <option value="Del Giro">Del Giro</option>
                  <option value="Del Giro">Supermercados</option>
                  <option value="Otro">Venta de Bienes inmuebles, 'BBRR'</option>
                  <option value="Del Giro">Activo Fijo</option>
                  <option value="Otro">IVA Uso Común</option>
                  <option value="Otro">IVA no Recuperable</option>
                  <option value="No Corresponde incluir">No Corresponde incluir</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Dirección */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Dirección"
                  value={formData.receptor.direccion}
                  onChange={(e) => handleInputChange(e, "receptor", "direccion")}
                  maxLength={70}
                />
              </Form.Group>
            </Col>

            {/* Comuna */}
            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Comuna"
                  value={formData.receptor.comuna}
                  onChange={(e) => handleInputChange(e, "receptor", "comuna")}
                  maxLength={20}
                />
              </Form.Group>
            </Col>

            {/* Ciudad */}
            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ciudad"
                  value={formData.receptor.ciudad}
                  onChange={(e) => handleInputChange(e, "receptor", "ciudad")}
                  maxLength={20}
                />
              </Form.Group>
            </Col>

            {/* Contacto */}
            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Contacto</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Contacto"
                  value={formData.receptor.contacto}
                  onChange={(e) => handleInputChange(e, "receptor", "contacto")}
                  maxLength={80}
                />
              </Form.Group>
            </Col>

            {/* RUT Solicita */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>RUT Solicita</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="RUT Solicita"
                  value={formData.receptor.rutSolicita}
                  onChange={handleRutSolicitaChange}
                  isInvalid={!!rutSolicitaError}
                />
                <Form.Control.Feedback type="invalid">
                  {rutSolicitaError}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Giro */}
            <Col md={8} className="mb-3">
              <Form.Group>
                <Form.Label>Giro</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Giro"
                  value={formData.receptor.giro}
                  onChange={(e) => handleInputChange(e, "receptor", "giro")}
                  maxLength={80}
                />
              </Form.Group>
            </Col>
          </Row>
        )}
      </div>



      {/* Transporte */}
      {/* <div className="border p-3 mb-4">
        <h5
          onClick={() => toggleSection("transporte")}
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          Transporte
          {visibleSections.transporte ? <FaChevronUp /> : <FaChevronDown />}
        </h5>
        {visibleSections.transporte && (
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>RUT Transporte</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="RUT Transporte"
                  value={formData.transporte.rutTransporte}
                  onChange={(e) =>
                    handleInputChange(e, "transporte", "rutTransporte")
                  }
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Patente</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Patente"
                  value={formData.transporte.patente}
                  onChange={(e) =>
                    handleInputChange(e, "transporte", "patente")
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        )}
      </div> */}

      {/* Productos */}
      <Form className="border p-3 mb-4">
        <h5>Productos</h5>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Cantidad</th>
              <th>Unidad</th>
              <th>Precio</th>
              <th>Descuento</th>
              <th>Subtotal</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {formData.productos.map((producto, index) => (
              <tr key={index}>
                <td>
                  <Form.Control
                    type="text"
                    value={producto.nombre}
                    maxLength={80}
                    onChange={(e) => actualizarProducto(index, "nombre", e.target.value)}
                  />
                </td>

                <td>
                  <Form.Control
                    type="text"
                    value={producto.descripcion}
                    maxLength={1000}
                    onChange={(e) => actualizarProducto(index, "descripcion", e.target.value)}
                  />
                </td>

                <td>
                  <Form.Control
                    type="text"
                    value={inputsTemporales[index]?.cantidad ?? formatearMiles(producto.cantidad)}
                    onChange={(e) => {
                      let input = e.target.value;
                      if (!/^[\d.,]*$/.test(input)) return;
                      const sinPuntos = input.replace(/\./g, '').replace(',', '.');
                      if (/^(\d{0,12})(\.\d{0,2})?$/.test(sinPuntos)) {
                        setInputsTemporales((prev) => ({
                          ...prev,
                          [index]: {
                            ...prev[index],
                            cantidad: input,
                          },
                        }));
                      }
                    }}
                    onBlur={() => {
                      const valor = inputsTemporales[index]?.cantidad || "";
                      const numero = parseFloat(valor.replace(/\./g, '').replace(',', '.'));
                      if (!isNaN(numero)) {
                        actualizarProducto(index, "cantidad", numero);
                        setInputsTemporales((prev) => ({
                          ...prev,
                          [index]: {
                            ...prev[index],
                            cantidad: formatearMiles(numero),
                          },
                        }));
                      }
                    }}
                    onFocus={() => {
                      setInputsTemporales((prev) => ({
                        ...prev,
                        [index]: {
                          ...prev[index],
                          cantidad: producto.cantidad?.toString().replace('.', ',') || '',
                        },
                      }));
                    }}
                  />
                </td>

                <td>
                  <Form.Control
                    type="text"
                    value={producto.unidad}
                    maxLength={4}
                    onChange={(e) => actualizarProducto(index, "unidad", e.target.value)}
                  />
                </td>

                <td>
                  <Form.Control
                    type="text"
                    value={inputsTemporales[index]?.precio ?? formatearMiles(producto.precio)}
                    onChange={(e) => {
                      let input = e.target.value;
                      if (!/^[\d.,]*$/.test(input)) return;
                      const sinPuntos = input.replace(/\./g, '').replace(',', '.');
                      if (/^(\d{0,12})(\.\d{0,2})?$/.test(sinPuntos)) {
                        setInputsTemporales((prev) => ({
                          ...prev,
                          [index]: {
                            ...prev[index],
                            precio: input,
                          },
                        }));
                      }
                    }}
                    onBlur={() => {
                      const valor = inputsTemporales[index]?.precio || "";
                      const numero = parseFloat(valor.replace(/\./g, '').replace(',', '.'));
                      if (!isNaN(numero)) {
                        actualizarProducto(index, "precio", numero);
                        setInputsTemporales((prev) => ({
                          ...prev,
                          [index]: {
                            ...prev[index],
                            precio: formatearMiles(numero),
                          },
                        }));
                      }
                    }}
                    onFocus={() => {
                      setInputsTemporales((prev) => ({
                        ...prev,
                        [index]: {
                          ...prev[index],
                          precio: producto.precio?.toString().replace('.', ',') || '',
                        },
                      }));
                    }}
                  />
                </td>

                <td>
                  <Form.Control
                    type="text"
                    value={producto.descuento === 0 ? '' : producto.descuento}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,3}([.,]\d{0,2})?$/.test(input) || input === "") {
                        actualizarProducto(index, "descuento", input);
                      }
                    }}
                    onBlur={(e) => {
                      let valor = e.target.value.replace(",", ".");
                      let numero = parseFloat(valor);
                      if (isNaN(numero) || numero < 0) numero = 0;
                      if (numero > 100) numero = 100;
                      actualizarProducto(index, "descuento", +numero.toFixed(2));
                    }}
                  />
                </td>

                <td>
                  {formatearMiles(
                    Math.round(parseFloat(
                      producto.cantidad * producto.precio *
                      (1 - parseFloat(producto.descuento || 0) / 100)
                    ))
                  )}
                </td>

                <td>
                  <Button variant="danger" size="sm" onClick={() => eliminarProducto(index)}>
                    Eliminar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>


        <Button
          variant="success"
          onClick={() =>
            setFormData((prev) => ({
              ...prev,
              productos: [
                ...prev.productos,
                {
                  nombre: "",
                  descripcion: "",
                  cantidad: 1,
                  unidad: "",
                  precio: 0,
                  descuento: 0,
                },
              ],
            }))
          }
        >
          Agregar Producto
        </Button>
      </Form>


      {/* Forma de Pago */}
      <Form className="border p-3 mb-4">
        <h5>Forma de Pago</h5>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={2}>
            Seleccionar
          </Form.Label>
          <Col sm={10}>
            <Form.Select
              value={formData.formaPago}
              onChange={handleFormaPagoChange}
            >
              <option value="1">Contado</option>
              <option value="2">Crédito</option>
              <option value="3">Sin Costo</option>
            </Form.Select>
          </Col>
        </Form.Group>
      </Form>

      {/* Referencias */}
      <Form className="border p-3 mb-4">
        <h5>Referencias</h5>
        <Form.Check
          type="checkbox"
          label="Activar referencias"
          checked={formData.mostrarReferencias}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              mostrarReferencias: e.target.checked,
            }))
          }
        />


        {formData.mostrarReferencias && (
          <>
            {/* Tabla de Referencias agregadas */}

            <Table striped bordered hover className="mt-3">
              <thead>
                <tr>
                  <th>Tipo de Documento</th>
                  <th>Folio Ref.</th>
                  <th>Fecha Ref.</th>
                  <th>Razón Referencia</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {formData.referencias.map((referencia, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Select
                        value={referencia.tipoDoc || ""}
                        onChange={(e) => actualizarReferencia(index, "tipoDoc", e.target.value)}
                      >
                        <option value="">Seleccionar</option>
                        {TIPOS_DOCUMENTO_REFERENCIA.map((tipo) => (
                          <option key={tipo.value} value={tipo.value}>
                            {tipo.label}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        placeholder="Folio"
                        maxLength={18}
                        value={referencia.folio || ""}
                        onChange={(e) => actualizarReferencia(index, "folio", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="date"
                        value={referencia.fecha || ""}
                        onChange={(e) => actualizarReferencia(index, "fecha", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        placeholder="Razón"
                        maxLength={90}
                        value={referencia.razon || ""}
                        onChange={(e) => actualizarReferencia(index, "razon", e.target.value)}
                      />
                    </td>
                    <td>
                      <Button variant="danger" size="sm" onClick={() => eliminarReferencia(index)}>
                        Eliminar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Button className="mt-3" variant="success" onClick={agregarReferencia}>
              Agregar referencia
            </Button>

          </>
        )}
      </Form>

      <Form className="border p-3 mb-4">
        <Row className="mb-2">
          <Col md={6}><strong>Sub Total</strong></Col>
          <Col md={6}>
            <Form.Control readOnly value={formatearMiles(subtotal)} />
          </Col>
        </Row>


        <Row className="mb-2">
          <Col md={6}><strong>Monto Neto</strong></Col>
          <Col md={6}>
            <Form.Control readOnly value={formatearMiles(montoNeto)} />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={3}><strong>IVA</strong></Col>
          <Col md={3}>
            <Form.Control readOnly value={`${tasaIVA} %`} />
          </Col>
          <Col md={6}>
            <Form.Control readOnly value={formatearMiles(montoIVA)} />
          </Col>
        </Row>

        <Row>
          <Col md={6}><strong>Total</strong></Col>
          <Col md={6}>
            <Form.Control readOnly value={formatearMiles(total)} />
          </Col>
        </Row>
      </Form>

      {/* Botones */}
      <div className="text-end">
        <Button variant="primary" className="me-2" onClick={handleVisuavilizar}>
          Validar y Visualizar
        </Button>
        <Button variant="secondary" className="me-2" onClick={handleLimpiarFormulario}>
          Limpiar
        </Button>

      </div>

      <Modal show={mostrarModalErrores} onHide={() => setMostrarModalErrores(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Errores en los datos del receptor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {erroresReceptor.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrores(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Errores Producto */}
      <Modal
        show={mostrarModalErroresProducto}
        onHide={() => setMostrarModalErroresProducto(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error en el producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {erroresProducto.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErroresProducto(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Cargando */}
      <Modal show={loading} centered backdrop="static">
        <Modal.Body className="text-center">
          <div className="my-3">
            <span className="spinner-border text-primary" role="status" />
          </div>
          <p>Cargando previsualización factura, por favor espera...</p>
        </Modal.Body>
      </Modal>

      {/* Modal referencias */}
      <Modal
        show={mostrarModalReferenciaInvalida}
        onHide={() => setMostrarModalReferenciaInvalida(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error en referencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {erroresReferencia.map((error, i) => (
              <li key={i}>{error}</li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setMostrarModalReferenciaInvalida(false)}>
            Entendido
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal de Error */}
      <Modal show={mostrarModalErrorApi} onHide={() => setMostrarModalErrorApi(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Error al enviar la factura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorApi}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrorApi(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal visor pdf */}

      <Modal show={mostrarModalPdf} onHide={() => setMostrarModalPdf(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Previsualización de Factura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="Vista previa de factura"
              width="100%"
              height="900px"
              style={{ border: 'none' }}
            />
          ) : (
            <p>Cargando PDF...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalPdf(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleEnviarFactura}>
            Confirmar y Enviar
          </Button>
        </Modal.Footer>
      </Modal>




    </Container >
  );
}

export default FacturaFormulario;
